








































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
interface DWTZ {
    accountBookId: number;
    amount: string;
    creditor: string;
    debtor: string;
    endDate: string;
    guaranteeMode: string;
    guaranteePeriod: string;
    guaranteeScope: string[] | string;
    isPublic: null,
    startDate: string;
    type: string;
    year: number;
    id?: number;
}

@Component
export default class Dwdb extends Vue {
    @Prop({ type: [Number, String] })
    year!: number;
    debtList = [
        "合同",
        "其他"
    ]
    timeList = [
        "期限",
        "未约定"
    ]
    ensureList = [
        "一般保证",
        "连带保证",
        "未约定"
    ]
    people = ""
    newRow: DWTZ = {
        accountBookId: this.$store.state.accountBook.id,
        amount: "",
        creditor: "",
        debtor: "",
        endDate: "",
        guaranteeMode: "",
        guaranteePeriod: "",
        guaranteeScope: [],
        isPublic: null,
        startDate: "",
        type: "",
        year: this.year,
    }
    dwList: DWTZ[] = []
    mounted() {
        this.fetchData()
    }
    async del(row: DWTZ) {
        const res = await Vue.axios.delete(`gsnb/dwdbxx/delete?id=${row.id}`);
        this.fetchData()
    }
    async changeRow(row: DWTZ) {
        let rowCopy = row
        rowCopy.guaranteeScope = rowCopy.guaranteeScope.toString();
        const res = await Vue.axios.post(`gsnb/dwdbxx/save`, rowCopy);
        if (res) this.fetchData()
    }
    async addRow() {
        if (this.newRow.startDate !== "" && this.newRow.endDate !== "" && this.newRow.amount !== "" && this.newRow.creditor !== "" && this.newRow.debtor !== "" && this.newRow.guaranteeMode !== "" && this.newRow.guaranteePeriod !== "" && (this.newRow.isPublic !== "" && this.newRow.isPublic !== null)) {
            let row = this.newRow
            row.guaranteeScope = row.guaranteeScope.toString();
            const res = await Vue.axios.post(`gsnb/dwdbxx/save`, row);
            if (res) {
                this.newRow = {
                    accountBookId: this.$store.state.accountBook.id,
                    amount: "",
                    creditor: "",
                    debtor: "",
                    endDate: "",
                    guaranteeMode: "",
                    guaranteePeriod: "",
                    guaranteeScope: [],
                    isPublic: null,
                    startDate: "",
                    type: "",
                    year: this.year,
                }
                this.fetchData()
            }
        }
    }
    async fetchData() {
        const res = await Vue.axios.get(`gsnb/dwdbxx/get?accountBookId=${this.$store.state.accountBook.id}&year=${this.year}`);
        res.data.data.forEach((v: DWTZ) => {
            if (v.guaranteeScope) v.guaranteeScope = v.guaranteeScope.toString().split(",");
            else v.guaranteeScope = [];
        });
        this.dwList = res.data.data
    }

    scopeList = ["主债权", "利息", "违约金", "损害赔偿金", "实现债权的费用", "其他约定"];
    scopeVisible = this.$store.state.accountBook.accountBookInfo.city.includes("广州");
}
